import { isFunction } from "../helpers/is-type.js";
import { createSubject } from "../helpers/subject.js";
import { getCurrentInstance } from "./part/node/component/hooks.js";
import _classPrivateFieldInitSpec from "../_virtual/_@oxc-project_runtime@0.151.0/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldSet2 from "../_virtual/_@oxc-project_runtime@0.151.0/helpers/esm/classPrivateFieldSet2.js";
import _classPrivateFieldGet2 from "../_virtual/_@oxc-project_runtime@0.151.0/helpers/esm/classPrivateFieldGet2.js";
//#region ../r-html/dist/render/hmr.js
var hmrComponentCache = /* @__PURE__ */ new WeakMap();
var hmrObservableCache = /* @__PURE__ */ new WeakMap();
var hmrObservablePendingCache = /* @__PURE__ */ new WeakMap();
var hmrSubject = createSubject();
var active = false;
var hasHmrComponent = (value) => isFunction(value) && hmrComponentCache.has(value);
var hotReplaceComponent = (values) => active ? values.map((value) => hasHmrComponent(value) ? hmrComponentCache.get(value) : value) : values;
var mixinHmrComponent = (ComponentClass) => {
	var _prevValues = /* @__PURE__ */ new WeakMap(), _hmrUnsubscribe = /* @__PURE__ */ new WeakMap();
	const C = class extends ComponentClass {
		constructor(node, tNode, parts, helper) {
			super(node, tNode, parts, helper);
			_classPrivateFieldInitSpec(this, _prevValues, []);
			_classPrivateFieldInitSpec(this, _hmrUnsubscribe, null);
			this.hmr();
		}
		commit(values) {
			const newValues = hotReplaceComponent(values);
			super.commit(newValues);
			_classPrivateFieldSet2(_prevValues, this, values);
		}
		hmr() {
			_classPrivateFieldSet2(_hmrUnsubscribe, this, hmrSubject.subscribe((value) => _classPrivateFieldGet2(_prevValues, this).includes(value) && this.commit(_classPrivateFieldGet2(_prevValues, this))));
		}
		destroy() {
			_classPrivateFieldGet2(_hmrUnsubscribe, this)?.call(this);
			super.destroy?.();
		}
	};
	return C;
};
function addHmrObservable(proxy) {
	if (!active) return;
	const hmrInstance = getCurrentInstance();
	if (!hmrInstance) return;
	const pending = hmrObservablePendingCache.get(hmrInstance) ?? [];
	if (!pending.includes(proxy)) {
		pending.push(proxy);
		hmrObservablePendingCache.set(hmrInstance, pending);
	}
}
function hotReloadObservable(component) {
	if (!active) return;
	const pending = hmrObservablePendingCache.get(component);
	if (!pending) return;
	hmrObservablePendingCache.delete(component);
	const previous = hmrObservableCache.get(component);
	hmrObservableCache.set(component, pending);
	if (!previous) return;
	pending.forEach((proxy, index) => {
		const prevProxy = previous[index];
		if (!prevProxy) return;
		Object.assign(proxy, prevProxy);
	});
}
//#endregion
export { addHmrObservable, hotReloadObservable, mixinHmrComponent };
